import { useState, useEffect, Suspense } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../../components/auth/AuthContext';
import AdminTabs from '../../components/admin/AdminTabs';
import ConferenceDetail from '../../components/admin/ConferenceDetail'

export default function ConferenceDetailPage() {
  const navigate = useNavigate();
  const params = useParams();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);

  const conferenceId = params.id as string;
  const isAuthenticated = currentUser && (currentUser.userType === 'internal' || currentUser.userType === 'admin');

  useEffect(() => {
    if (isAuthenticated) {
      // User is authenticated with admin privileges
    } 
    setLoading(false);
  }, [navigate, isAuthenticated]);

  const handleBackToConferences = () => {
    navigate('/admin/conferences');
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Alert severity="warning">
          Please log in to access this page.
        </Alert>
      </Box>
    );
  }

  return (
    <Suspense fallback={
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    }>
      <Box sx={{ minHeight: '100vh', py: 4,mt: 8 }}>
        <Container maxWidth="lg">

          <AdminTabs currentPath="/admin/conferences" />
          
          <Box sx={{ mt: 3 }}>
            <Button 
              variant="outlined" 
              onClick={handleBackToConferences}
              sx={{ mb: 3 }}
            >
              ← Back to Conferences
            </Button>
            
            <ConferenceDetail conferenceId={conferenceId} />
          </Box>
        </Container>
      </Box>
    </Suspense>
  );
}